import { frontDB } from "frontDB";
import { useDocuments } from "Pages/Documents/useDocuments";
import React from "react";

function BreadCrumb() {
  const { locationId, navigateToPath, currentNode } = useDocuments();
  const { locations } = frontDB();

  const buildPath = (node) => {
    const path = [];
    while (node) {
      path.unshift(node);
      node = node.parent;
    }
    return path;
  };

  const path = buildPath(currentNode);

  return (
    <div>
      {path.map((node, index) => (
        <span key={node.id}>
          {index > 0 && " / "}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigateToPath(node);
            }}
          >
            {node.name}
          </a>
        </span>
      ))}
    </div>
  );
}

export default BreadCrumb;
